import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpaceBoardsService } from '../../../../services/space-boards.service';
import { Position } from '../../../../services/items-canvas.service';
import { YCanvas } from '../../wb-canvas/fabric-utils';

@Injectable({
  providedIn: 'root',
})
export class BoardItemsStaggeringService {
  private readonly STAGGERING_GAP = 40;

  private itemPositionToNextStaggeredPosition = new Map<string, Position>();
  private canvas?: YCanvas;

  private boundClearPositionsMap = this.clearPositionsMap.bind(this);
  private boardChangeSubscription?: Subscription;

  constructor(private spaceBoardsService: SpaceBoardsService) {}
  public initService(canvas: YCanvas) {
    this.canvas = canvas;
    this.canvas?.on('vpt:changed', this.boundClearPositionsMap);
    this.boardChangeSubscription = this.spaceBoardsService.activeSpaceSelectedBoard$.subscribe(
      this.boundClearPositionsMap,
    );
  }

  // When a new item is inserted, we are making sure that it is not exactly at the same position as any other item,
  // and if it is it will be shifted to the bottom right by a certain amount
  public getStaggeredPosition(position: Position, boardId: string): Position {
    // Staggering only for the current board as the items positions on different boards shouldn't affect each other's
    if (this.canvas?.boardId !== boardId) {
      return position;
    }
    const existingItemPosition = this.itemPositionToNextStaggeredPosition.get(this.toKey(position));

    const newItemPosition = existingItemPosition
      ? {
          top: existingItemPosition.top + this.STAGGERING_GAP,
          left: existingItemPosition.left + this.STAGGERING_GAP,
        }
      : position;

    this.itemPositionToNextStaggeredPosition.set(this.toKey(position), newItemPosition);

    return newItemPosition;
  }

  public destroyService() {
    this.canvas?.off('vpt:changed', this.boundClearPositionsMap);
    this.boardChangeSubscription?.unsubscribe();
  }

  private clearPositionsMap() {
    this.itemPositionToNextStaggeredPosition.clear();
  }

  toKey(position: Position) {
    return `${position.top}${position.left}`;
  }
}
